import { useState } from 'react';

export const useCopy = () => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = textToCopy => {
    navigator.clipboard.writeText(textToCopy);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return { isCopied, handleCopyClick };
};
